import { useToast } from "@design";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { addAgentPinMutation, listAgentPinsOptions, listAgentPinsQueryKey, removeAgentPinMutation } from "@/api";

/** Starred agents are Home's "Pinned agents": same query, so both update together. */
export function useAgentStars() {
  const { t } = useTranslation("agents", { keyPrefix: "star" });
  const toast = useToast();
  const queryClient = useQueryClient();
  const pins = useQuery({ ...listAgentPinsOptions(), select: (r) => new Set(r.data.map((a) => a.uuid)) });
  const options = {
    onError: () => toast.error(t("failed")),
    onSettled: () => queryClient.invalidateQueries({ queryKey: listAgentPinsQueryKey() }),
  };
  const add = useMutation({ ...addAgentPinMutation(), ...options });
  const remove = useMutation({ ...removeAgentPinMutation(), ...options });
  const isStarred = (uuid: string) => pins.data?.has(uuid) ?? false;
  return {
    isStarred,
    toggle: (uuid: string) =>
      isStarred(uuid) ? remove.mutate({ path: { agent_uuid: uuid } }) : add.mutate({ body: { agentUuid: uuid } }),
  };
}
